import { BindWalletOptionsV2 } from '../types';
import { createVerificationIntent } from '../utils/createVerificationIntent';

export const createWalletBindingApi2 = async (apiHost: string, { wallet, ...params }: BindWalletOptionsV2) => {
    return createVerificationIntent(apiHost, {
        ...params,
        flow: wallet,
    });
};
